import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Button from '../buttons/Button'
import close from './../../images/close.svg'
import SelectsWritable from './../form/selects/SelectsWritable'
import Input from './../form/inputs/Input';

const ModalProduct = ( { index, closeModal, disabledLeasingItemsStatus, filterLeasingItems, props, forceValidateFromName, setForceValidateFromName, fvError, errorCheckboxCopy, copyCategories, enableInputsByProvider, disableForm, enableCategory, updateValue, lockInputs, disableProducts, checkSessionProductsLength, remove } ) => {
    let [ load, setLoad ] = useState(false);

    const dispatch = useDispatch();
    let products     = useSelector(state => state.products);
    let isShop       = useSelector(state => state.isShop);

    useEffect(() => {
        if(!load) {
            setLoad(true);
        }
    }, [load])
    return (
        <div className="modal-message">
            <div className="bg" onClick={() => closeModal()}></div>
            <div className="modal">
                <div className="actions">
                    <div className="delete-item">
                        {/* <p role="button" tabindex="0" onClick={ () => remove( index ) }>Delete</p> */}
                        <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={ () => remove( index ) }>
                            <path d="M10.9817 2.87679V1.08008H6.6658V2.87679M2.97187 15.0617L3.82625 21.0801H14.016L16.0137 5.63216H1.72172V15.1999L8.99022 12.8567V7.10848M17 5.58441H0.647461V3.02128H17V5.58441Z" stroke="black" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="close" onClick={() => closeModal()}>
                        <img src={close} alt="Close" />
                    </div>
                </div>
                <div className="content">
                    <div className="form-box">
                        <div className={ "inputs" }>
                            <div className={ "row"} >
                                <div className="col">
                                    <SelectsWritable
                                        id={`product-type-modal-${index}`}
                                        data={ load && disabledLeasingItemsStatus && filterLeasingItems() } 
                                        showEmptyError={ ( props.data && props.data.length > 0 ? true : false )} 
                                        forceValidate={ props.forceValidate } 
                                        forceValidateItems={ props.forceValidateItems }
                                        forceValidateFromName={ forceValidateFromName }
                                        val={ products[index].type }
                                        setForceValidateFromName={ () => setForceValidateFromName(false) }
                                        label="Category" 
                                        placeholder="Category"
                                        index={ index }
                                        checkFv={ () => fvError() }
                                        errorCheckboxCopy={ errorCheckboxCopy }
                                        copyCategories={ copyCategories }
                                        disabled={ (props.disableSelect && !enableInputsByProvider || disableForm && !enableInputsByProvider) ? (enableCategory ? false : true) : false }
                                        setFunction={ (val) => val && updateValue(val, index, 'type') } 
                                        />
                                </div>
                                <div className="col">
                                    <Input 
                                        id={`product-name-${index}`}
                                        name={"product-"+index}
                                        required={ true }
                                        setFunction={ val => { updateValue(val, index, 'name'); } }
                                        type="text"
                                        label={ "Product name" }
                                        placeholder="Product name"
                                        val={ products[index].name }
                                        size="full" 
                                        regExp={ /(?!^\d+$)^.+$/ }
                                        notSpecial={ isShop ? false : true }
                                        // notSpecial={false}
                                        minChar={ 3 } 
                                        forceValidate={ props.forceValidate }
                                        forceValidateItems={ props.forceValidateItems }
                                        setValidateSelectField={ true }
                                        cloud={ true }
                                        setForceValidateFromName={ () => setForceValidateFromName(true) } 
                                        // disabledForce={ disableForm }
                                        disabledForce={ enableInputsByProvider ? false : disableForm }
                                        disabled={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } 
                                        activeInput={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } 
                                        checkFv={ () => fvError() }  />
                                </div>
                                <div className="col col-row">
                                    <Input 
                                        id={`product-price-netto-${index}`}
                                        name="price"
                                        required={ true }
                                        setFunction={ val => { updateValue(val, index, 'price') } }
                                        type="text"
                                        formatPrice={ true }
                                        label={ "Price" }
                                        val={ products[index].price }
                                        size="full" 
                                        unit="AED"
                                        regExp={/^[0-9\,\.\s]+$/}
                                        allowChars={/^[0-9\,\.\s]+$/}
                                        minChar={ 1 } 
                                        forceValidate={ props.forceValidate } 
                                        forceValidateItems={ props.forceValidateItems } 
                                        // disabledForce={ disableForm }
                                        disabledForce={ enableInputsByProvider ? false : disableForm }
                                        checkFv={ () => fvError() } 
                                        disabled={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } 
                                        activeInput={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } />
                                    <Input 
                                        id={`product-quantity-${index}`}
                                        name="quantity"
                                        required={ true }
                                        setFunction={ val => { updateValue(val, index, 'quantity') } }
                                        type="text"
                                        label={ "Quantity" }
                                        val={ products[index].quantity }
                                        size="full"
                                        unit="pcs"
                                        formatAmount={ true }
                                        regExp={/^[0-9]{0,5}[\s?]{0,1}[0-9]{0,5}$/}
                                        allowChars={/^[0-9]{0,5}$/}
                                        minChar={ 1 } 
                                        maxChar={ 3 }
                                        max={ 100 }
                                        forceValidate={ props.forceValidate }
                                        forceValidateItems={ props.forceValidateItems } 
                                        // disabledForce={ disableForm }
                                        disabledForce={ enableInputsByProvider ? false : disableForm }
                                        checkFv={ () => fvError() } 
                                        disabled={ (disableProducts || lockInputs) && checkSessionProductsLength( index ) ? true : false } 
                                        activeInput={ (disableProducts || lockInputs) && checkSessionProductsLength( index )  ? true : false }  />
                                        {products[index].equal &&
                                            <div className="form-item normal-label form-item-price">
                                                    <p className="equal-price">{products[index].equal}<span>AED net</span></p>
                                                    <small>All values excludes 5% VAT</small>
                                            </div>
                                        }
                                </div>
                                <div className="col">
                                    <Button class="black" title="Save" arrow setFunction={ () =>  closeModal() } />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalProduct;